import { TextInput } from "@volkswagen-onehub/components-core";
import * as React from "react";
export function Filter(props) {
    const { filter } = props;
    return React.createElement(TextInput, { placeholder: "Filter Term", type: "text", onChange: filter });
}
